import { apiSlice } from '../apiSlice';
import { SuccessResponse } from '../DTO/common.interface';
import {
	FaceSheetDTO,
	FaceSheetRequest,
	FaceSheetSaveDTO,
} from '../DTO/forms-management/faceSheet';

export const enquiryRecord = apiSlice.injectEndpoints({
	endpoints: (builder) => ({
		getFaceSheetList: builder.query<SuccessResponse<FaceSheetDTO[]>, string>({
			query: (id) => ({
				url: `/web/form/face-sheet/list/${id}`,
				method: 'GET',
			}),
			providesTags: ['FaceSheetList'],
		}),
		deleteFaceSheet: builder.mutation<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/face-sheet/${id}`,
				method: 'DELETE',
			}),

			invalidatesTags: ['FaceSheetList'],
		}),
		faceSheetHasDraft: builder.query<SuccessResponse<any>, string>({
			query: (id) => ({
				url: `/web/form/face-sheet/has-draft/${id}`,
				method: 'GET',
			}),
			keepUnusedDataFor: 0,
		}),
		getFaceSheetDraft: builder.query<
			SuccessResponse<FaceSheetSaveDTO>,
			{ id: string; type: string }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/face-sheet/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		continueFaceSheetDraft: builder.mutation<
			SuccessResponse<FaceSheetSaveDTO>,
			{ id: string; type: number }
		>({
			query: ({ id, type }) => ({
				url: `/web/form/face-sheet/to-create/${id}/${type}`,
				method: 'GET',
			}),
		}),
		editFaceSheet: builder.mutation<SuccessResponse<any>, FaceSheetRequest>({
			query: (body) => ({
				url: `/web/form/face-sheet/${body.id}`,
				method: 'PUT',
				body,
			}),
		}),
		createFaceSheet: builder.mutation<SuccessResponse<any>, FaceSheetRequest>({
			query: (body) => ({
				url: `/web/form/face-sheet`,
				method: 'POST',
				body,
			}),
		}),
		getFaceSheetDetail: builder.query<SuccessResponse<FaceSheetDTO>, string>({
			query: (id) => ({
				url: `/web/form/face-sheet/${id}`,
				method: 'GET',
			}),
		}),
	}),
});

export const {
	useGetFaceSheetListQuery,
	useDeleteFaceSheetMutation,
	useFaceSheetHasDraftQuery,
	useGetFaceSheetDraftQuery,
	useContinueFaceSheetDraftMutation,
	useEditFaceSheetMutation,
	useCreateFaceSheetMutation,
	useGetFaceSheetDetailQuery,
} = enquiryRecord;
